import handbackSlice from "./handbackSlice";
const handbackActions = handbackSlice.actions;
export const { setHandbackStatus } = handbackActions;
